module.exports = __webpack_public_path__ + "static/media/shopping-options.49337d9d.gif";